import { createContext, useContext } from 'react';

/**
 * Context for whether the portal is ungated for threading emails by most recent reply
 *
 * @param {Object}  value
 * @param {Boolean} value.shouldThreadEmailReplies     the boolean value that represents whether emails should be threaded by most recent reply.
 * @param {function} value.toggleShouldThreadEmailReplies  a callback that sets whether this emails should be threaded by most recent reply
 */

export const ThreadEmailRepliesContext = /*#__PURE__*/createContext({
  shouldThreadEmailReplies: false,
  toggleShouldThreadEmailReplies: () => {}
});
export const useThreadEmailRepliesContext = () => useContext(ThreadEmailRepliesContext);